var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktokLogo = function SvgTiktokLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M15.75 9.563A8.96 8.96 0 0 0 21 11.25V7.5a5.25 5.25 0 0 1-5.25-5.25H12v12.375a2.625 2.625 0 1 1-3.75-2.373V8.25C5.266 8.782 3 11.488 3 14.625a6.375 6.375 0 1 0 12.75 0z"
  })));
};
export default SvgTiktokLogo;